import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/dialog'

// 关闭 Vue 的生产提示
Vue.config.productionTip = false

// 创建 Vue 实例
const app = new Vue({
  store,
  router,
  render: h => h(App)
})

app.$mount('#app')
